import { PaymentGroup, PaymentGroupMeta, PaymentMethod, PaymentMethodMeta, PaymentGroupActions } from "./Payment";

export type ICodPaymentGroup = PaymentGroup<CodPaymentGroupMeta, CodPaymentMethodData> & {
    paymentActions: CodPaymentGroupActions;
};
export type CodPaymentGroupMeta = PaymentGroupMeta;

export type CodPaymentGroupActions = PaymentGroupActions<CodPaymentMethodData> & CodSpecificActions;

export interface CodPaymentMethodMeta extends PaymentMethodMeta {
    popupMessage?: string;
    ctaMsg?: string;
    halfCardInfo?: CodConsentInfo;
    halfCard?: TURBO_COD_CONFIRM_HALF_CARD_TYPE | null;
}

export enum TURBO_COD_CONFIRM_HALF_CARD_TYPE {
    CONSENT = "CONSENT",
    SUBTLE = "SUBTLE",
}

export interface CodConsentInfo {
    title: string;
    subtitle: string;
    primaryCta: string;
    secondaryCta: string;
    waitTime?: string;
}

export interface TurboCodPaymentMethodMeta extends PaymentMethodMeta {
    ctaMsg?: string;
    ctaText?: string;
    halfCard?: TURBO_COD_CONFIRM_HALF_CARD_TYPE | null;
    halfCardInfo?: CodConsentInfo;
}

export type CodPaymentMethodData = PaymentMethod<CodPaymentMethodMeta | TurboCodPaymentMethodMeta>;

export interface CodSpecificActions {
    onLoadCodHalfCard?: (flow: string) => void;
    onPlaceCodHalfCardCTa?: (flow: string, isSliderCompleted?: "yes" | "no") => void;
    onCancelHalfCard?: (flow: string) => void;
}
